<template>
  <div class="base-circular-progress">
    <svg
      class="base-circular-progress__svg"
      :class="{ 'is-indeterminate': indeterminate }"
      :width="size"
      :height="size"
      :viewBox="`0 0 ${size} ${size}`"
    >
      <!-- track -->
      <circle
        :cx="center"
        :cy="center"
        :r="radius"
        :stroke="trackColor"
        :stroke-width="thickness"
        fill="none"
        opacity="0.55"
      />
      <!-- progress arc -->
      <circle
        class="base-circular-progress__progress-circle"
        :cx="center"
        :cy="center"
        :r="radius"
        :stroke="progressColor"
        :stroke-width="thickness"
        fill="none"
        :stroke-linecap="roundedCaps ? 'round' : 'butt'"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
        :transform="`rotate(-90 ${center} ${center})`"
      />
    </svg>
    <div class="base-circular-progress__label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: 'BaseCircularProgress',
  props: {
    progressPercent: { type: Number, default: 0 },
    label: { type: String, default: '' },
    size: { type: Number, default: 24 }, // px
    thickness: { type: Number, default: 3 },
    trackColor: { type: String, default: '#bdc9d6' },
    progressColor: { type: String, default: '#253765' },
    roundedCaps: { type: Boolean, default: true },
    indeterminate: { type: Boolean, default: false },
  },
  computed: {
    clamped() {
      const v = Number(this.indeterminate ? 100 : this.progressPercent);
      return Math.max(0, Math.min(100, isFinite(v) ? v : 0));
    },
    center() {
      return this.size / 2;
    },
    radius() {
      return (this.size - this.thickness) / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    dashOffset() {
      return this.circumference * (1 - this.clamped / 100);
    },
  },
};
</script>

<style scoped lang="scss">
.base-circular-progress {
  display: grid;
  place-items: center;
  position: relative;

  &__svg {
    display: block;
  }
  &__label {
    position: absolute;
    font-size: $font-size-xsmall;
    font-weight: 700;
  }
  &__progress-circle {
    transition: stroke-dashoffset 600ms cubic-bezier(0.22, 0.61, 0.36, 1);
    will-change: stroke-dashoffset;
  }

  .is-indeterminate {
    animation: spin 1.8s linear infinite;
  }
  .is-indeterminate .base-circular-progress__progress-circle {
    stroke-dasharray: 80, 200; /* arc size */
    stroke-dashoffset: 0;
    animation: dash 2.5s ease-in-out infinite;
  }
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -15;
  }
  100% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: -120;
  }
}
</style>
